export enum AuditEntityType {
  vatDeclaration = 'vat_declarations',
  corporateTaxBalance = 'corporate_tax_balances',
  corporateTaxRefund = 'corporate_tax_refunds',
  taxReport = 'tax_reports',
  bilan = 'bilans',
  corporateTaxInstalment = 'corporate_tax_instalments',
  cvaeBalance = 'cvae_balances',
  cvaeInstalment = 'cvae_instalments',
  das2 = 'das2s',
  tasks = 'tasks',
  attestations = 'attestations',
  contracts = 'contracts',
  missionAcceptances = 'mission_acceptances',
  directorRemuneration = 'director_remunerations'
}
